import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import { Bell, X } from 'lucide-react';
import FormLowBalanceAlert, { FORM_LOW_BALANCE_ALERT_ID } from '../forms/FormLowBalanceAlert';
import { useTranslation } from 'react-i18next';

export default function SheetLowBalanceAlert({ open, onClose, company, companyBalance, onSubmit, isSubmitting = false }) {
    const { t } = useTranslation();
    const handleOpenChange = (isOpen) => {
        if (!isOpen) {
            onClose();
        }
    };

    return (
        <Sheet open={open} onOpenChange={handleOpenChange}>
            <SheetContent
                showCloseButton={false}
                className="w-full md:w-[480px] flex flex-col p-0 overflow-hidden md:rounded-l-2xl"
            >
                {/* Header */}
                <div className="bg-card border-b border-border px-5 py-4 flex items-center justify-between shrink-0">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-lg bg-surface flex items-center justify-center">
                            <Bell className="h-5 w-5 text-foreground" strokeWidth={1.5} />
                        </div>
                        <div>
                            <SheetTitle className="text-[16px] text-foreground font-medium">
                                {t('account:alerteSoldeBas')}
                            </SheetTitle>
                        </div>
                    </div>
                    <Button
                        variant="plain"
                        color="neutral"
                        size="auto"
                        onClick={onClose}
                        className="w-10 h-10 rounded-lg bg-surface border border-border text-foreground hover:bg-border"
                    >
                        <X className="h-5 w-5" strokeWidth={1.5} />
                    </Button>
                </div>

                {/* Body */}
                <FormLowBalanceAlert
                    company={company}
                    companyBalance={companyBalance}
                    onSubmit={onSubmit}
                />

                {/* Footer */}
                <div className="bg-card border-t border-border p-5 shrink-0">
                    <SubmitButton
                        form={FORM_LOW_BALANCE_ALERT_ID}
                        className="w-full p-4"
                        isSubmitting={isSubmitting}
                        loadingText={t('account:enregistrement')}
                    >
                        {t('account:enregistrerLAlerte')}
                    </SubmitButton>
                </div>
            </SheetContent>
        </Sheet>
    );
}
